import { documentTemplateConstants } from './documentTemplate.constants'

const initialState = {
  loadingDocumentTemplates: false,
  documentTemplates: [],
  documentTemplatesForBoat: [],
  addingFileToDocument: false,
  error: null,
  addingDocumentTemplateToBoat: false,
  savingDocumentTemplate: false,
}

export function documentTemplates(state = initialState, action) {
  switch (action.type) {
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_USER:
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT:
      return {
        ...state,
        loadingDocumentTemplates: true,
      }
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_USER_SUCCESS:
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingDocumentTemplates: false,
        documentTemplates: action.documentTemplates,
      }
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_USER_ERROR:
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_CLIENT_ERROR:
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingDocumentTemplates: false,
        error: action.error,
      }
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_BOAT:
      return {
        ...state,
        loadingDocumentTemplates: true,
      }
    case documentTemplateConstants.FETCH_DOCUMENT_TEMPLATES_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingDocumentTemplates: false,
        documentTemplatesForBoat: action.documentTemplatesForBoat,
      }
    case documentTemplateConstants.UPDATE_DOCUMENT_TEMPLATE:
      return {
        ...state,
        savingDocumentTemplate: true,
      }
    case documentTemplateConstants.UPDATE_DOCUMENT_TEMPLATE_SUCCESS:
    case documentTemplateConstants.UPDATE_DOCUMENT_TEMPLATE_ERROR:
      return {
        ...state,
        savingDocumentTemplate: false,
      }
    case documentTemplateConstants.ADDING_FILE_TO_DOCUMENT:
      return {
        ...state,
        addingFileToDocument: true,
      }
    case documentTemplateConstants.ADDING_FILE_TO_DOCUMENT_SUCCESS:
      return {
        ...state,
        addingFileToDocument: false,
      }
    case documentTemplateConstants.ADDING_FILE_TO_DOCUMENT_ERROR:
      return {
        ...state,
        addingFileToDocument: false,
        error: action.error,
      }
    case documentTemplateConstants.ADD_DOCUMENT_TEMPLATE_TO_BOAT_LOADING:
      return {
        ...state,
        addingDocumentTemplateToBoat: true,
      }
    case documentTemplateConstants.ADD_DOCUMENT_TEMPLATE_TO_BOAT_SUCCESS:
    case documentTemplateConstants.ADD_DOCUMENT_TEMPLATE_TO_BOAT_ERROR:
      return {
        ...state,
        addingDocumentTemplateToBoat: false,
      }
    default:
      return state
  }
}
